import moment from 'moment';
import * as Constants from './../Constants';

class EventStatus {

  static eventList = {};

  static getEventStatus(event) {
    let result = Constants.EVENT_NOT_READY;
    const now = moment();
    const shownOn = moment(event.shownOn);
    const delta = shownOn - now;
    const lastStatus = EventStatus.eventList[event._id];
    if (lastStatus === Constants.EVENT_CANCELLED) {
      return lastStatus;
    }
    if (delta > 0) {
      // event in the future
      if (delta <= Constants.PRE_START_MINUTES * Constants.MS_MINUTE) {
        // event is near in the future about to start
        result = Constants.EVENT_ABOUT_TO_START;
      } else {
        // event is farther out in the future
        result = Constants.EVENT_NOT_READY;
      }
    } else {
      // event in the past
      if (delta <= -1 * Constants.MAX_EVENT_MINUTES * Constants.MS_MINUTE) {
        // event is too far out in the past
        result = Constants.EVENT_NOT_READY;
        delete EventStatus.eventList[event._id];
      } else if (lastStatus) {
        result = lastStatus;
      } else {
        // we begin in the stopped state
        result = Constants.EVENT_STOPPED;
        EventStatus.eventList[event._id] = result;
      }
    }
    return result;
  }

  static setEventStatus(event, status) {
    const lastStatus = EventStatus.getEventStatus(event);
    if (lastStatus === Constants.EVENT_NOT_READY) {
      throw new Error("cant set status to " + status + " event is NOT READY");
    }
    if (status === Constants.EVENT_STARTED || status === Constants.EVENT_STOPPED ||
            status === Constants.EVENT_CANCELLED || status === Constants.EVENT_SHOW_URL || status === Constants.EVENT_TELECON_STARTED ||
            status === Constants.EVENT_BINGO_BALL || status === Constants.EVENT_BINGO_GAME) {
      if (lastStatus === Constants.EVENT_ABOUT_TO_START) {
        throw new Error("cant set status to " + status + " event is ABOUT TO START");
      }
      EventStatus.eventList[event._id] = status;
    } else {
      throw new Error("cant set status to " + status + " unknown status");
    }
  }
}

export default EventStatus;
